export const STAGING_FRONTEND_HOSTNAME = 'dealbinder-staging.web.app';
export const STAGING_BACKEND_URL = 'https://dealbinder-staging.ew.r.appspot.com/v1';
export const DEVELOPMENT_FRONTEND_HOSTNAME = 'dev.dealbinder.com';
export const DEVELOPMENT_BACKEND_URL = 'https://devs.dealbinder.com/v1';
// export const DEVELOPMENT_BACKEND_URL = 'http://localhost:8080/v1';
export const PRODUCTION_FRONTEND_HOSTNAME = 'app.dealbinder.com';
export const PRODUCTION_BACKEND_URL = 'https://apps.dealbinder.com/v1';
